import { render } from "./NavigationMobile.vue?vue&type=template&id=38d484d4&scoped=true"
import script from "./NavigationMobile.vue?vue&type=script&lang=js"
export * from "./NavigationMobile.vue?vue&type=script&lang=js"

import "./NavigationMobile.vue?vue&type=style&index=0&id=38d484d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d484d4"]])

export default __exports__